
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 8A8 8 0 110 8a8 8 0 0116 0zm-2 0a6 6 0 01-9.493 4.879l8.372-8.372A5.973 5.973 0 0114 8zM3.098 11.46l8.362-8.362a6 6 0 00-8.363 8.363z","fill":"currentColor"}})])
          )
        }
      }
    